<template>
  <nav class="fixed z-20 w-full top-0 bg-white border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center">
            <inertia-link :href="'/' + $page.language">
              <img class="block h-8 w-auto" src="/img/logo.png" alt />
            </inertia-link>
          </div>
          <div class="hidden lg:-my-px lg:ml-10 lg:flex items-center">
            <inertia-link
              :href="item.full_url"
              v-for="(item, index) in $page.mainMenu"
              :class="{ 'ml-2 xl:ml-4': index > 0 }"
              class="h-8 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-900 focus:outline-none hover:border-red-500 focus:border-red-700 transition duration-150 ease-in-out"
              :key="item.id"
            >{{ item.title }}</inertia-link>
          </div>
        </div>
        <div class="hidden lg:ml-6 lg:flex lg:items-center">
          <inertia-link
            v-if="$page.frontAuth.user"
            :href="route('profile', $page.language)"
            class="h-8 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-900 hover:text-gray-700 hover:border-red-500 focus:outline-none focus:text-gray-700 focus:border-red-300 transition duration-150 ease-in-out"
          >{{ __("Your Profile") }}</inertia-link>
          <inertia-link
            v-if="$page.frontAuth.user"
            :href="route('logout', $page.language)"
            class="h-8 ml-2 xl:ml-4 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-900 hover:text-gray-700 hover:border-red-500 focus:outline-none focus:text-gray-700 focus:border-red-300 transition duration-150 ease-in-out"
            method="post"
          >
            <i class="fa fa-sign-out"></i>
          </inertia-link>
          <inertia-link
            v-if="!$page.frontAuth.user"
            :href="route('login.show', $page.language)"
            class="h-8 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-gray-900 hover:text-gray-700 hover:border-red-500 focus:outline-none focus:text-gray-700 focus:border-red-300 transition duration-150 ease-in-out"
          >{{ __("Login") }}</inertia-link>
          <inertia-link :href="route('front.home', 'sl')" class="ml-4">
            <span class="flag-icon flag-icon-si"></span>
          </inertia-link>
          <inertia-link :href="route('front.home', 'en')" class="ml-2">
            <span class="flag-icon flag-icon-gb"></span>
          </inertia-link>
          <inertia-link :href="route('front.home', 'de')" class="ml-2">
            <span class="flag-icon flag-icon-de"></span>
          </inertia-link>
        </div>
        <div class="-mr-2 flex items-center lg:hidden">
          <button
            @click="open = !open"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out"
          >
            <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path
                :class="{'hidden': open, 'inline-flex': !open }"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                :class="{'hidden': !open, 'inline-flex': open }"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div :class="{'block': open, 'hidden': !open}">
      <div class="pt-2 pb-3">
        <inertia-link
          :href="item.full_url"
          v-for="(item, index) in $page.mainMenu"
          :class="{ 'mt-1': index > 0 }"
          class="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 focus:outline-none focus:text-red-800 focus:bg-red-100 focus:border-red-700 transition duration-150 ease-in-out"
          :key="item.id"
        >{{ item.title }}</inertia-link>
      </div>
      <div class="pt-4 pb-3 border-t border-gray-200">
        <div class="mt-0">
          <inertia-link
            v-if="$page.frontAuth.user"
            :href="route('profile', $page.language)"
            class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
          >{{ __("Your Profile") }}</inertia-link>
          <inertia-link
            v-if="$page.frontAuth.user"
            :href="route('logout', $page.language)"
            class="mt-1 block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
            method="post"
          >{{__("Sign out")}}</inertia-link>
          <inertia-link
            v-if="!$page.frontAuth.user"
            :href="route('login.show', $page.language)"
            class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
          >{{ __("Login") }}</inertia-link>
          <div class="my-3">
            <inertia-link :href="route('front.home', 'sl')" class="ml-4">
              <span class="flag-icon flag-icon-si"></span>
            </inertia-link>
            <inertia-link :href="route('front.home', 'en')" class="ml-2">
              <span class="flag-icon flag-icon-gb"></span>
            </inertia-link>
            <inertia-link :href="route('front.home', 'de')" class="ml-2">
              <span class="flag-icon flag-icon-de"></span>
            </inertia-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
